import { t } from 'i18next';
import { message } from 'ui';

export const onSuccessReport = () => message.success(t('Successfully reported.'));

export const onErrorReport = () => message.error(t('Something went wrong.'));
